<div class="error-screen">
  <div class="error">
    <h1 class="title">Page Not Found</h1>
    <p class="error-text">Either something went wrong, or the link you used is not valid.</p>
    <p class="error-text" *ngIf="currentErrorType === errorType.GroupNotFound">
      If you’re trying to sign up for {{ productName }}, please check to make sure you entered the URL exactly as it is
      specified in the information provided by your sponsoring organization.
    </p>
    <p class="error-text">
      If you already have a Kumanu account,
      <br />
      click the button below to sign in.
    </p>
    <a routerLink="/login" class="button button-pill" (click)="clearUserInfo()">Sign In</a>
  </div>
</div>
